/** Default drawer footer height for our drawer layouts */
export const DRAWER_FOOTER_HEIGHT = 64;
